export const currencyCodes = [
    {
        "Code": "AED",
        "Currency": "UAE Dirham",
        "Symbol": "د.إ"
    },
    {
        "Code": "AFN",
        "Currency": "Afghani",
        "Symbol": "AFN"
    },
    {
        "Code": "ALL",
        "Currency": "Lek",
        "Symbol": "ALL"
    },
    {
        "Code": "AMD",
        "Currency": "Armenian Dram",
        "Symbol": "AMD"
    },
    {
        "Code": "ANG",
        "Currency": "Netherlands Antillean Guilder",
        "Symbol": "ANG"
    },
    {
        "Code": "AOA",
        "Currency": "Kwanza",
        "Symbol": "AOA"
    },
    {
        "Code": "ARS",
        "Currency": "Argentine Peso",
        "Symbol": "ARS"
    },
    {
        "Code": "AUD",
        "Currency": "Australian Dollar",
        "Symbol": "$"
    },
    {
        "Code": "AWG",
        "Currency": "Aruban Florin",
        "Symbol": "AWG"
    },
    {
        "Code": "AZN",
        "Currency": "Azerbaijan Manat",
        "Symbol": "AZN"
    },
    {
        "Code": "BAM",
        "Currency": "Convertible Mark",
        "Symbol": "BAM"
    },
    {
        "Code": "BBD",
        "Currency": "Barbados Dollar",
        "Symbol": "BBD"
    },
    {
        "Code": "BDT",
        "Currency": "Taka",
        "Symbol": "৳"
    },
    {
        "Code": "BGN",
        "Currency": "Bulgarian Lev",
        "Symbol": "BGN"
    },
    {
        "Code": "BHD",
        "Currency": "Bahraini Dinar",
        "Symbol": "BHD"
    },
    {
        "Code": "BIF",
        "Currency": "Burundi Franc",
        "Symbol": "BIF"
    },
    {
        "Code": "BMD",
        "Currency": "Bermudian Dollar",
        "Symbol": "BMD"
    },
    {
        "Code": "BND",
        "Currency": "Brunei Dollar",
        "Symbol": "$"
    },
    {
        "Code": "BOB",
        "Currency": "Boliviano",
        "Symbol": "BOB"
    },
    {
        "Code": "BOV",
        "Currency": "Mvdol",
        "Symbol": "BOV"
    },
    {
        "Code": "BRL",
        "Currency": "Brazilian Real",
        "Symbol": "R$"
    },
    {
        "Code": "BSD",
        "Currency": "Bahamian Dollar",
        "Symbol": "BSD"
    },
    {
        "Code": "BTN",
        "Currency": "Ngultrum",
        "Symbol": "BTN"
    },
    {
        "Code": "BWP",
        "Currency": "Pula",
        "Symbol": "BWP"
    },
    {
        "Code": "BYN",
        "Currency": "Belarusian Ruble",
        "Symbol": "BYN"
    },
    {
        "Code": "BZD",
        "Currency": "Belize Dollar",
        "Symbol": "BZD"
    },
    {
        "Code": "CAD",
        "Currency": "Canadian Dollar",
        "Symbol": "$"
    },
    {
        "Code": "CDF",
        "Currency": "Congolese Franc",
        "Symbol": "CDF"
    },
    {
        "Code": "CHE",
        "Currency": "WIR Euro",
        "Symbol": "CHE"
    },
    {
        "Code": "CHF",
        "Currency": "Swiss Franc",
        "Symbol": "CHF"
    },
    {
        "Code": "CHW",
        "Currency": "WIR Franc",
        "Symbol": "CHW"
    },
    {
        "Code": "CLF",
        "Currency": "Unidad de Fomento",
        "Symbol": "CLF"
    },
    {
        "Code": "CLP",
        "Currency": "Chilean Peso",
        "Symbol": "CLP"
    },
    {
        "Code": "CNH",
        "Currency": "Yuan Renminbi (International)",
        "Symbol": "CNH"
    },
    {
        "Code": "CNY",
        "Currency": "Yuan Renminbi (Domestic)",
        "Symbol": "¥"
    },
    {
        "Code": "COP",
        "Currency": "Colombian Peso",
        "Symbol": "COP"
    },
    {
        "Code": "COU",
        "Currency": "Unidad de Valor Real",
        "Symbol": "COU"
    },
    {
        "Code": "CRC",
        "Currency": "Costa Rican Colon",
        "Symbol": "CRC"
    },
    {
        "Code": "CUC",
        "Currency": "Peso Convertible",
        "Symbol": "CUC"
    },
    {
        "Code": "CUP",
        "Currency": "Cuban Peso",
        "Symbol": "CUP"
    },
    {
        "Code": "CVE",
        "Currency": "Cabo Verde Escudo",
        "Symbol": "CVE"
    },
    {
        "Code": "CZK",
        "Currency": "Czech Koruna",
        "Symbol": "CZK"
    },
    {
        "Code": "DJF",
        "Currency": "Djibouti Franc",
        "Symbol": "DJF"
    },
    {
        "Code": "DKK",
        "Currency": "Danish Krone",
        "Symbol": "kr"
    },
    {
        "Code": "DOP",
        "Currency": "Dominican Peso",
        "Symbol": "DOP"
    },
    {
        "Code": "DZD",
        "Currency": "Algerian Dinar",
        "Symbol": "DZD"
    },
    {
        "Code": "EGP",
        "Currency": "Egyptian Pound",
        "Symbol": "£"
    },
    {
        "Code": "ERN",
        "Currency": "Nakfa",
        "Symbol": "ERN"
    },
    {
        "Code": "ETB",
        "Currency": "Ethiopian Birr",
        "Symbol": "ETB"
    },
    {
        "Code": "EUR",
        "Currency": "Euro",
        "Symbol": "€"
    },
    {
        "Code": "FJD",
        "Currency": "Fiji Dollar",
        "Symbol": "FJD"
    },
    {
        "Code": "FKP",
        "Currency": "Falkland Islands Pound",
        "Symbol": "FKP"
    },
    {
        "Code": "GBP",
        "Currency": "Pound Sterling",
        "Symbol": "£"
    },
    {
        "Code": "GEL",
        "Currency": "Lari",
        "Symbol": "GEL"
    },
    {
        "Code": "GHS",
        "Currency": "Ghana Cedi",
        "Symbol": "GHS"
    },
    {
        "Code": "GIP",
        "Currency": "Gibraltar Pound",
        "Symbol": "GIP"
    },
    {
        "Code": "GMD",
        "Currency": "Dalasi",
        "Symbol": "GMD"
    },
    {
        "Code": "GNF",
        "Currency": "Guinean Franc",
        "Symbol": "GNF"
    },
    {
        "Code": "GTQ",
        "Currency": "Quetzal",
        "Symbol": "GTQ"
    },
    {
        "Code": "GYD",
        "Currency": "Guyana Dollar",
        "Symbol": "GYD"
    },
    {
        "Code": "HKD",
        "Currency": "Hong Kong Dollar",
        "Symbol": "$"
    },
    {
        "Code": "HNL",
        "Currency": "Lempira",
        "Symbol": "HNL"
    },
    {
        "Code": "HTG",
        "Currency": "Gourde",
        "Symbol": "HTG"
    },
    {
        "Code": "HUF",
        "Currency": "Forint",
        "Symbol": "HUF"
    },
    {
        "Code": "IDR",
        "Currency": "Rupiah",
        "Symbol": "Rp"
    },
    {
        "Code": "ILS",
        "Currency": "New Israeli Sheqel",
        "Symbol": "ILS"
    },
    {
        "Code": "INR",
        "Currency": "Indian Rupee",
        "Symbol": "₹"
    },
    {
        "Code": "IQD",
        "Currency": "Iraqi Dinar",
        "Symbol": "IQD"
    },
    {
        "Code": "IRR",
        "Currency": "Iranian Rial",
        "Symbol": "IRR"
    },
    {
        "Code": "ISK",
        "Currency": "Iceland Krona",
        "Symbol": "ISK"
    },
    {
        "Code": "JMD",
        "Currency": "Jamaican Dollar",
        "Symbol": "JMD"
    },
    {
        "Code": "JOD",
        "Currency": "Jordanian Dinar",
        "Symbol": "JOD"
    },
    {
        "Code": "JPY",
        "Currency": "Yen",
        "Symbol": "¥"
    },
    {
        "Code": "KES",
        "Currency": "Kenyan Shilling",
        "Symbol": "KES"
    },
    {
        "Code": "KGS",
        "Currency": "Som",
        "Symbol": "KGS"
    },
    {
        "Code": "KHR",
        "Currency": "Riel",
        "Symbol": "៛"
    },
    {
        "Code": "KMF",
        "Currency": "Comorian Franc ",
        "Symbol": "KMF"
    },
    {
        "Code": "KPW",
        "Currency": "North Korean Won",
        "Symbol": "KPW"
    },
    {
        "Code": "KRW",
        "Currency": "Won",
        "Symbol": "₩"
    },
    {
        "Code": "KWD",
        "Currency": "Kuwaiti Dinar",
        "Symbol": "KWD"
    },
    {
        "Code": "KYD",
        "Currency": "Cayman Islands Dollar",
        "Symbol": "KYD"
    },
    {
        "Code": "KZT",
        "Currency": "Tenge",
        "Symbol": "KZT"
    },
    {
        "Code": "LAK",
        "Currency": "Lao Kip",
        "Symbol": "LAK"
    },
    {
        "Code": "LBP",
        "Currency": "Lebanese Pound",
        "Symbol": "LBP"
    },
    {
        "Code": "LKR",
        "Currency": "Sri Lanka Rupee",
        "Symbol": "Rs"
    },
    {
        "Code": "LRD",
        "Currency": "Liberian Dollar",
        "Symbol": "LRD"
    },
    {
        "Code": "LSL",
        "Currency": "Loti",
        "Symbol": "LSL"
    },
    {
        "Code": "LYD",
        "Currency": "Libyan Dinar",
        "Symbol": "LYD"
    },
    {
        "Code": "MAD",
        "Currency": "Moroccan Dirham",
        "Symbol": "MAD"
    },
    {
        "Code": "MDL",
        "Currency": "Moldovan Leu",
        "Symbol": "MDL"
    },
    {
        "Code": "MGA",
        "Currency": "Malagasy Ariary",
        "Symbol": "MGA"
    },
    {
        "Code": "MKD",
        "Currency": "Denar",
        "Symbol": "MKD"
    },
    {
        "Code": "MMK",
        "Currency": "Kyat",
        "Symbol": "K"
    },
    {
        "Code": "MNT",
        "Currency": "Tugrik",
        "Symbol": "MNT"
    },
    {
        "Code": "MOP",
        "Currency": "Pataca",
        "Symbol": "MOP"
    },
    {
        "Code": "MRU",
        "Currency": "Ouguiya",
        "Symbol": "MRU"
    },
    {
        "Code": "MUR",
        "Currency": "Mauritius Rupee",
        "Symbol": "MUR"
    },
    {
        "Code": "MVR",
        "Currency": "Rufiyaa",
        "Symbol": "MVR"
    },
    {
        "Code": "MWK",
        "Currency": "Malawi Kwacha",
        "Symbol": "MWK"
    },
    {
        "Code": "MXN",
        "Currency": "Mexican Peso",
        "Symbol": "$"
    },
    {
        "Code": "MXV",
        "Currency": "Mexican Unidad de Inversion (UDI)",
        "Symbol": "MXV"
    },
    {
        "Code": "MYR",
        "Currency": "Malaysian Ringgit",
        "Symbol": "RM"
    },
    {
        "Code": "MZN",
        "Currency": "Mozambique Metical",
        "Symbol": "MZN"
    },
    {
        "Code": "NAD",
        "Currency": "Namibia Dollar",
        "Symbol": "NAD"
    },
    {
        "Code": "NGN",
        "Currency": "Naira",
        "Symbol": "₦"
    },
    {
        "Code": "NIO",
        "Currency": "Cordoba Oro",
        "Symbol": "NIO"
    },
    {
        "Code": "NOK",
        "Currency": "Norwegian Krone",
        "Symbol": "kr"
    },
    {
        "Code": "NPR",
        "Currency": "Nepalese Rupee",
        "Symbol": "Rs"
    },
    {
        "Code": "NZD",
        "Currency": "New Zealand Dollar",
        "Symbol": "$"
    },
    {
        "Code": "OMR",
        "Currency": "Rial Omani",
        "Symbol": "OMR"
    },
    {
        "Code": "PAB",
        "Currency": "Balboa",
        "Symbol": "PAB"
    },
    {
        "Code": "PEN",
        "Currency": "Sol",
        "Symbol": "PEN"
    },
    {
        "Code": "PGK",
        "Currency": "Kina",
        "Symbol": "PGK"
    },
    {
        "Code": "PHP",
        "Currency": "Philippine Peso",
        "Symbol": "₱"
    },
    {
        "Code": "PKR",
        "Currency": "Pakistan Rupee",
        "Symbol": "₨"
    },
    {
        "Code": "PLN",
        "Currency": "Zloty",
        "Symbol": "zł"
    },
    {
        "Code": "PYG",
        "Currency": "Guarani",
        "Symbol": "PYG"
    },
    {
        "Code": "QAR",
        "Currency": "Qatari Rial",
        "Symbol": "ر.ق"
    },
    {
        "Code": "RON",
        "Currency": "Romanian Leu",
        "Symbol": "RON"
    },
    {
        "Code": "RSD",
        "Currency": "Serbian Dinar",
        "Symbol": "RSD"
    },
    {
        "Code": "RUB",
        "Currency": "Russian Ruble",
        "Symbol": "₽"
    },
    {
        "Code": "RWF",
        "Currency": "Rwanda Franc",
        "Symbol": "RWF"
    },
    {
        "Code": "SAR",
        "Currency": "Saudi Riyal",
        "Symbol": "ر.س"
    },
    {
        "Code": "SBD",
        "Currency": "Solomon Islands Dollar",
        "Symbol": "SBD"
    },
    {
        "Code": "SCR",
        "Currency": "Seychelles Rupee",
        "Symbol": "SCR"
    },
    {
        "Code": "SDG",
        "Currency": "Sudanese Pound",
        "Symbol": "SDG"
    },
    {
        "Code": "SEK",
        "Currency": "Swedish Krona",
        "Symbol": "kr"
    },
    {
        "Code": "SGD",
        "Currency": "Singapore Dollar",
        "Symbol": "$"
    },
    {
        "Code": "SHP",
        "Currency": "Saint Helena Pound",
        "Symbol": "SHP"
    },
    {
        "Code": "SLE",
        "Currency": "Leone",
        "Symbol": "SLE"
    },
    {
        "Code": "SLL",
        "Currency": "Leone",
        "Symbol": "SLL"
    },
    {
        "Code": "SOS",
        "Currency": "Somali Shilling",
        "Symbol": "SOS"
    },
    {
        "Code": "SRD",
        "Currency": "Surinam Dollar",
        "Symbol": "SRD"
    },
    {
        "Code": "SSP",
        "Currency": "South Sudanese Pound",
        "Symbol": "SSP"
    },
    {
        "Code": "STN",
        "Currency": "Dobra",
        "Symbol": "STN"
    },
    {
        "Code": "SVC",
        "Currency": "El Salvador Colon",
        "Symbol": "SVC"
    },
    {
        "Code": "SYP",
        "Currency": "Syrian Pound",
        "Symbol": "SYP"
    },
    {
        "Code": "SZL",
        "Currency": "Lilangeni",
        "Symbol": "SZL"
    },
    {
        "Code": "THB",
        "Currency": "Baht",
        "Symbol": "฿"
    },
    {
        "Code": "TJS",
        "Currency": "Somoni",
        "Symbol": "TJS"
    },
    {
        "Code": "TMT",
        "Currency": "Turkmenistan New Manat",
        "Symbol": "TMT"
    },
    {
        "Code": "TND",
        "Currency": "Tunisian Dinar",
        "Symbol": "TND"
    },
    {
        "Code": "TOP",
        "Currency": "Pa’anga",
        "Symbol": "TOP"
    },
    {
        "Code": "TRY",
        "Currency": "Turkish Lira",
        "Symbol": "₺"
    },
    {
        "Code": "TTD",
        "Currency": "Trinidad and Tobago Dollar",
        "Symbol": "TTD"
    },
    {
        "Code": "TWD",
        "Currency": "New Taiwan Dollar",
        "Symbol": "NT$"
    },
    {
        "Code": "TZS",
        "Currency": "Tanzanian Shilling",
        "Symbol": "TZS"
    },
    {
        "Code": "UAH",
        "Currency": "Hryvnia",
        "Symbol": "UAH"
    },
    {
        "Code": "UGX",
        "Currency": "Uganda Shilling",
        "Symbol": "UGX"
    },
    {
        "Code": "USD",
        "Currency": "US Dollar",
        "Symbol": "$"
    },
    {
        "Code": "USN",
        "Currency": "US Dollar (Next day)",
        "Symbol": "USN"
    },
    {
        "Code": "UYI",
        "Currency": "Uruguay Peso en Unidades Indexadas (UI)",
        "Symbol": "UYI"
    },
    {
        "Code": "UYU",
        "Currency": "Peso Uruguayo",
        "Symbol": "UYU"
    },
    {
        "Code": "UYW",
        "Currency": "Unidad Previsional",
        "Symbol": "UYW"
    },
    {
        "Code": "UZS",
        "Currency": "Uzbekistan Sum",
        "Symbol": "UZS"
    },
    {
        "Code": "VED",
        "Currency": "Bolívar Soberano",
        "Symbol": "VED"
    },
    {
        "Code": "VES",
        "Currency": "Bolívar Soberano",
        "Symbol": "VES"
    },
    {
        "Code": "VND",
        "Currency": "Dong",
        "Symbol": "₫"
    },
    {
        "Code": "VUV",
        "Currency": "Vatu",
        "Symbol": "VUV"
    },
    {
        "Code": "WST",
        "Currency": "Tala",
        "Symbol": "WST"
    },
    {
        "Code": "XAF",
        "Currency": "CFA Franc BEAC",
        "Symbol": "XAF"
    },
    {
        "Code": "XAG",
        "Currency": "Silver",
        "Symbol": "XAG"
    },
    {
        "Code": "XAU",
        "Currency": "Gold",
        "Symbol": "XAU"
    },
    {
        "Code": "XBA",
        "Currency": "Bond Markets Unit European Composite Unit (EURCO)",
        "Symbol": "XBA"
    },
    {
        "Code": "XBB",
        "Currency": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
        "Symbol": "XBB"
    },
    {
        "Code": "XBC",
        "Currency": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
        "Symbol": "XBC"
    },
    {
        "Code": "XBD",
        "Currency": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
        "Symbol": "XBD"
    },
    {
        "Code": "XCD",
        "Currency": "East Caribbean Dollar",
        "Symbol": "XCD"
    },
    {
        "Code": "XDR",
        "Currency": "SDR (Special Drawing Right)",
        "Symbol": "XDR"
    },
    {
        "Code": "XOF",
        "Currency": "CFA Franc BCEAO",
        "Symbol": "XOF"
    },
    {
        "Code": "XPD",
        "Currency": "Palladium",
        "Symbol": "XPD"
    },
    {
        "Code": "XPF",
        "Currency": "CFP Franc",
        "Symbol": "XPF"
    },
    {
        "Code": "XPT",
        "Currency": "Platinum",
        "Symbol": "XPT"
    },
    {
        "Code": "XSU",
        "Currency": "Sucre",
        "Symbol": "XSU"
    },
    {
        "Code": "XUA",
        "Currency": "ADB Unit of Account",
        "Symbol": "XUA"
    },
    {
        "Code": "XXX",
        "Currency": "The codes assigned for transactions where no currency is involved",
        "Symbol": "XXX"
    },
    {
        "Code": "YER",
        "Currency": "Yemeni Rial",
        "Symbol": "YER"
    },
    {
        "Code": "ZAR",
        "Currency": "Rand",
        "Symbol": "R"
    },
    {
        "Code": "ZMW",
        "Currency": "Zambian Kwacha",
        "Symbol": "ZMW"
    },
    {
        "Code": "ZWL",
        "Currency": "Zimbabwe Dollar",
        "Symbol": "ZWL"
    }
]